var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoostEfficiencyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 62,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.476 54.937c-9-2.204-16.06-9.352-18.137-18.402",
    stroke: "#BCC0C4",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.214 35.286c0 7.1-5.757 12.857-12.857 12.857-7.101 0-12.857-5.757-12.857-12.857s5.757-12.857 12.857-12.857c7.101 0 12.857 5.756 12.857 12.857",
    fill: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.714 31c0-13.61 11.034-24.643 24.643-24.643C49.967 6.357 61 17.391 61 31c0 13.61-11.034 24.643-24.643 24.643",
    stroke: "#EE4900",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.134 19.58c-4.72-6.318-13.68-7.622-20.011-2.913a14.188 14.188 0 00-4.927 6.683l.47.375c.54-.585 1.117-1.143 1.78-1.635 5.394-4.011 12.99-3.48 16.726 1.816l6.361-3.73c-.133-.198-.255-.402-.4-.596",
    fill: "#F4A27F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.134 19.58c-4.72-6.318-13.68-7.622-20.011-2.913a14.188 14.188 0 00-4.927 6.683l.47.375c.54-.585 1.117-1.143 1.78-1.635 5.394-4.011 12.99-3.48 16.726 1.816l6.361-3.73c-.133-.198-.255-.402-.4-.596z",
    stroke: "#EE4900",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.094 23.762l-.534-.674L37.62 31.21a4.254 4.254 0 00-1.264-.21 4.286 4.286 0 104.286 4.285c0-.014-.004-.027-.004-.04l11.455-11.484z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.094 23.762l-.534-.674L37.62 31.21a4.254 4.254 0 00-1.264-.21 4.286 4.286 0 104.286 4.285c0-.014-.004-.027-.004-.04l11.455-11.484z",
    stroke: "#999",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.537 3.576A29.9 29.9 0 0036.357 1M61.001 13.888a30.172 30.172 0 00-8.388-8.107",
    stroke: "#999",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.571 16L1 31h5.357c0 16.569 13.432 30 30 30 16.569 0 30-13.431 30-30 0-4.317-.912-8.421-2.553-12.13",
    stroke: "#999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EE4900",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M36.357 6.357v3.215M24.036 9.659l1.607 2.783M15.016 18.679l2.783 1.607M11.714 31h3.215M57.698 43.321l-2.783-1.607M61 31h-3.214M57.698 18.679l-2.783 1.607M48.678 9.659l-1.607 2.783"
  }))));
}
export default SvgBoostEfficiencyIcon;